import script from "./OrdersList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersList.vue?vue&type=script&setup=true&lang=js"

import "./OrdersList.vue?vue&type=style&index=0&id=03ce7586&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ce7586"]])

export default __exports__